<script setup>
import MarkdownPage from "@components/MarkdownPage.vue";
</script>

<template>
    <Transition name="panel" appear>
        <MarkdownPage title="About" slug="about" />
    </Transition>
</template>
